import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import SecondaryLargeButton from "../../../components/_utils/CommonButtons/SecondaryLargeButton/SecondaryLargeButton";
import TertiaryTopRoundButton from "../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import CommonCardDashboard from "../../../components/_utils/CommonCardDashboard";
import CommonToast from "../../../components/_utils/CommonToast";
import { getAllFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount";
import { resetToggle } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  getEntities,
  updateEntities,
} from "../../../redux/features/Settings/Management/entities";
import { resetIsCreateAcc } from "../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const FieldForceAccountDashboard = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [amt, setAmt] = useState("1000");
  const [amount, setAmount] = useState("1000");

  const { allfieldForceAccountData, allfieldForceAccountLoading } = useSelector(
    (state) => state.fieldForceAccount,
  );

  const MAX_LIMIT = 100000;

  const [transactionLimitModal, setTransactionLimitModal] = useState(false);
  const services = useSelector((state) => state.refreshToken.services) ?? [];

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const totalCount =
    allfieldForceAccountData?.total_count ??
    GlobalConfiguration?.lengthCheckZero;

  const isViewAllDisabled =
    allfieldForceAccountLoading ||
    totalCount === GlobalConfiguration?.lengthCheckZero;

  const handleAmountChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, "");

    if (!/^\d*$/.test(rawValue)) return;

    if (rawValue === "") {
      setAmount("");
      return;
    }

    if (rawValue.length > 15) return;

    const numericValue = Number(rawValue);

    if (numericValue > MAX_LIMIT) {
      toast.dismiss();
      CommonToast({
        text: "The amount cannot exceed INR1,00,000",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
      return; // do NOT update state
    }

    setAmount(rawValue);
  };

  const onMount = () => {
    dispatch(getAllFieldForceAccount({}));
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [dispatch, props?.internalAccount]);

  useEffect(() => {
    onMount();
  }, [markerData]);

  const handleDatacardClick = (approvalStatus) => {
    const routeMap = {
      approved: "/field_force_account_dashboard/field_force_account_view_all",
      pending:
        services.includes("FFAAccount") || services?.includes("Admin")
          ? "/field_force_account_dashboard/field_force_account_approval"
          : (services.includes("FFVAccount") || services?.includes("Admin")) &&
              !services.includes("FFAAccount")
            ? "/field_force_account_dashboard/field_force_account_view_all"
            : navigate("/feature_not_assigned", {
                state: {
                  unavailableService: "FFAAccount",
                },
              }),
    };

    dispatch(resetToggle());
    navigate(routeMap[approvalStatus], {
      state: { approvalStatus },
    });
  };

  const approvedValue =
    allfieldForceAccountData?.summary?.approved_accounts_count === undefined
      ? GlobalConfiguration.dashboardPrimaryCount
      : allfieldForceAccountData?.summary?.approved_accounts_count;

  const pendingValue =
    allfieldForceAccountData?.summary?.pending_accounts_count === undefined
      ? GlobalConfiguration.dashboardPrimaryCount
      : allfieldForceAccountData?.summary?.pending_accounts_count;

  const accountTypesSummary =
    allfieldForceAccountData && allfieldForceAccountData.summary
      ? Object.entries(allfieldForceAccountData.summary)
      : [];

  const order = [
    "pending_accounts_count",
    "approved_accounts_count",
    //  "rejected_accounts_count",
    //  "blocked_accounts_count",
    //  "archived_accounts_count",
  ];

  const [hasScroll, setHasScroll] = useState(false);
  const divRef = useRef(null);

  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const formatWithCommas = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("en-IN").format(value);
  };

  const removeCommas = (value) => value.replace(/,/g, "");

  const checkScroll = () => {
    if (divRef.current) {
      const hasVerticalScroll =
        divRef.current.scrollHeight > divRef.current.clientHeight;
      const hasHorizontalScroll =
        divRef.current.scrollWidth > divRef.current.clientWidth;
      setHasScroll(hasVerticalScroll || hasHorizontalScroll);

      const atStart =
        divRef.current.scrollLeft === GlobalConfiguration.lengthCheckZero;
      const atEnd =
        Math.ceil(divRef.current.scrollLeft + divRef.current.clientWidth) >=
        divRef.current.scrollWidth;
      setIsAtStart(atStart);
      setIsAtEnd(atEnd);
    }
  };

  const isUpdateDisabled =
    !amount || Number(amount) === GlobalConfiguration.lengthCheckZero;

  const handleUpdate = async () => {
    const payload = {
      entity_id: id,
      field_force_limit: amount,
    };

    let response = await dispatch(updateEntities(payload));

    if (response?.payload) {
      setAmt(amount);
      setTransactionLimitModal(false);
      dispatch(getEntities({ page_no: 1, page_size: 10 }));
    } else {
      setTransactionLimitModal(false);
    }
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => {
      window.removeEventListener("resize", checkScroll);
    };
  }, [accountTypesSummary]);
  return (
    <>
      <div className=" internalDashboardView bg-primary-bg w-width-full overflow-y-auto px-padding-base pb-padding-md h-screen ">
        <div className="Qsmd:h-navbar-breadcrumb-height"></div>
        <div className="flex justify-center px-padding-md">
          <div className="flex gap-x-gap-md flex-col mt-margin-md pb-padding-xl Qlg:pb-padding-base max-w-tab-width-normal w-width-full Qlg:flex-row mb-margin-xl Qlg:mb-margin-base Qlg:relative">
            <div className="Qlg:w-dashboard-left-card-width">
              <div className="w-width-full flex flex-col pt-padding-md Qsmd:pt-padding-base mt-margin-xl Qsmd:mt-margin-base ">
                <div className="w-width-full p-padding-sm fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center z-z-index-tooltip Qlg:hidden rounded-bl-border-radius-sm rounded-br-border-radius-sm">
                  <div className="flex flex-row items-center">
                    <img
                      src={ICONS?.FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE}
                      alt="FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE"
                      className="h-icon-lg w-icon-lg mr-margin-sm"
                    />
                    <div className="flex flex-col">
                      <div className="flex items-center">
                        <p className="text-primary-bg font-semibold text-font-md">
                          Field force
                        </p>
                      </div>
                      <p className="text-primary-bg text-font-xs">Accounts</p>
                    </div>
                  </div>
                </div>
                <div className="w-width-full bg-primary-nav flex flex-col sm:flex-row rounded-border-radius-md items-center z-z-index-header gap-2">
                  <div className="w-width-full flex">
                    <SecondaryLargeButton
                      btnText="Create field force account"
                      btnType="button"
                      handleFunction={() => {
                        const requiredService = "FFUAccount";
                        if (services?.includes(requiredService)) {
                          navigate(
                            "/field_force_account_dashboard/create_field_force_account",
                          );
                          // toast.info("Feature coming soon", toast_position);
                          // dispatch(resetServices());

                          dispatch(resetIsCreateAcc());
                        } else {
                          navigate("/feature_not_assigned", {
                            state: { unavailableService: requiredService },
                          });
                        }
                      }}
                      enabledTextColor="var(--text-primary)"
                      disabledTextColor="var(--text-secondary)"
                      enabledBgColor="var(--primary-nav)"
                      hoverOption="white"
                      isLoaderNeeded={false}
                      isLoading={false}
                      icon={ICONS?.ADD_BUTTON_WHITE}
                      imgColor="var(--text-primary)"
                      iconAlt="add_button_white"
                      isDisabled={
                        !(
                          services?.includes("FFUAccount") ||
                          services?.includes("Admin")
                        )
                      }
                    />
                  </div>
                </div>

                <div className="w-width-full rounded-border-radius-md relative overflow-hidden mt-margin-md">
                  <h2 className="bg-primary-card flex items-center justify-between pl-padding-md transition-all duration-animation-medium">
                    <div className="flex items-center gap-gap-sm">
                      <img
                        src={ICONS?.APPROVAL_STATUS}
                        alt="transaction header"
                        className="w-icon-sm"
                      />
                      <p className="text-font-sm font-semibold font-sans text-text-secondary">
                        Account statuses
                      </p>
                    </div>
                    <div className="flex">
                      <div className="border-dividing"></div>
                      <TertiaryTopRoundButton
                        btnText="View all"
                        icon={ICONS?.ARROW_RIGHT_WHITE}
                        imgColor="var(--text-primary)"
                        btnType="button"
                        hoverOption="white"
                        handleFunction={async () => {
                          await dispatch(resetToggle());
                          if (
                            allfieldForceAccountData?.summary
                              ?.pending_accounts_count ??
                            false
                          ) {
                            navigate(
                              "/field_force_account_dashboard/field_force_account_view_all",
                            );
                          }

                          // toast.info("Feature coming soon", toast_position);
                        }}
                        // handleFunction={() => {}}
                        isDisabled={isViewAllDisabled}
                        enabledTextColor={"var(--text-primary)"}
                        disabledTextColor={"var(--text-secondary)"}
                        enabledBgColor={"var(--primary-card)"}
                        disabledBgColor={"var(--primary-card)"}
                      />
                    </div>
                  </h2>
                  <div>
                    <div className="flex flex-col Qsmd:flex-row gap-gap-base p-padding-base bg-primary-nav  ">
                      <CommonCardDashboard
                        label={
                          services?.includes("FFAAccount") ||
                          services?.includes("Admin")
                            ? "Require approval"
                            : "Pending accounts"
                        }
                        count={pendingValue ?? "00"}
                        color="var(--pending)"
                        loader={allfieldForceAccountLoading}
                        onClick={() => handleDatacardClick("pending")}
                      />
                      <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base "></div>

                      <CommonCardDashboard
                        label="Approved accounts"
                        count={approvedValue}
                        color="var(--awaiting)"
                        loader={allfieldForceAccountLoading}
                        onClick={() => handleDatacardClick("approved")}
                      />
                    </div>
                  </div>
                </div>

                <div className="w-width-full mt-margin-md bg-primary-card rounded-t-border-radius-md rounded-b-border-radius-md">
                  <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
                    <span className="flex items-center text-sm font-semibold text-text-secondary ">
                      <img
                        src={ICONS?.STATISTICS}
                        alt="Statistics Header"
                        className="h-icon-sm mr-margin-sm"
                      />
                      Field force accounts
                    </span>
                  </h2>
                  <div className="border-border border-primary-bg mx-margin-md"></div>

                  <div className="relative w-width-full lg:py-padding-md overflow-hidden contents lg:block ">
                    <div className="flex flex-col items-center justify-center lg:justify-start h-height-full text-center p-padding-md">
                      <div className="flex flex-col justify-center items-center w-width-full">
                        <img
                          src={ICONS?.NO_STATISTICS_AVAILABLE}
                          alt="No Slides"
                          className="mb-margin-sm w-graphic-width-md h-graphic-rectangle-height-md flex-shrink-0"
                        />
                        <p className="text-font-xs text-text-primary">
                          No statistics available due to the absence of data.
                          Once data is present,
                          <br />
                          statistics will appear.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceAccountDashboard;
